// BASE常量
const BASE = {
  tysq: '//tysq.suning.com',
  siller: '//dt.suning.com/',
  imgUrl: '//vcs.suning.com/',
  passport: '//api.passport.pptv.com',
  smsp: '//ppsports.suning.com',
  sacs: '//ppsports.suning.com',
  smds: '//smds.suning.com',
  spums: '//spums.suning.com',
  lbgp: '//lbgp2.suning.com',
  mccp: '//mccp.suning.com/mccp-web',
  sacs: '//isports.suning.com/sacs-web',
  sisp: '//ppsports.suning.com/sisp-web',
};

if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

const { origin } = location;
if (origin.indexOf('dev') > -1 || origin.indexOf('10.24') > -1 || origin.indexOf('8080') > -1) {
  BASE.tysq = '//tysqxgpre.cnsuning.com';
  BASE.passport = 'http://10.200.20.21:8090/passport';
  BASE.siller = '//dtxgpre.cnsuning.com/';
  BASE.imgUrl = '//vcsprexg.cnsuning.com/';
  BASE.smsp = '//ppwebxgpre.cnsuning.com';
  BASE.smds = '//smdssit.cnsuning.com';
  BASE.spums = '//spumssit.cnsuning.com';
  BASE.lbgp = '//lbgpsit.cnsuning.com';
  BASE.mccp = '/mccp-web';
  BASE.sacs = '/sacs-web';
  BASE.sisp = '/sisp-web';

} else if (origin.indexOf('sit') > -1) {
  BASE.tysq = '//tysqxgpre.cnsuning.com';
  BASE.passport = 'http://10.200.20.21:8090/passport';
  BASE.siller = '//dtxgpre.cnsuning.com/';
  BASE.imgUrl = '//vcsprexg.cnsuning.com/';
  BASE.smsp = '//ppwebxgpre.cnsuning.com';
  BASE.smds = '//smdssit.cnsuning.com';
  BASE.spums = '//spumssit.cnsuning.com';
  BASE.lbgp = '//lbgpsit.cnsuning.com';
  BASE.mccp = '//mccpsit.cnsuning.com/mccp-web';
  BASE.sacs = '//sportsmembersit.cnsuning.com/sacs-web';
  BASE.sisp = '//ppsportssit.cnsuning.com/sisp-web';
} else if (origin.indexOf('pre') > -1) {
  BASE.tysq = '//tysqxgpre.cnsuning.com';
  BASE.passport = 'http://10.200.20.21:8090/passport';
  BASE.siller = '//dtxgpre.cnsuning.com/';
  BASE.imgUrl = '//vcsxgpre.cnsuning.com/';
  BASE.smsp = '//ppwebxgpre.cnsuning.com';
  BASE.smds = '//smdsxgpre.cnsuning.com';
  BASE.spums = '//spumsxgpre.cnsuning.com';
  BASE.lbgp = '//lbgpxgpre.cnsuning.com';
  BASE.mccp = '//mccp.cnsuning.com/mccp-web';
  BASE.sacs = '//sportsmemberpre.cnsuning.com/sacs-web';
  BASE.sisp = '//ppwebxgpre.cnsuning.com/sisp-web';
}

const DI = {
  //登录相关
  portoUrl: '//fp.suning.com/bennu-collector/fp/porto.js', // 设备指纹接入方式
  portoServiceUrl: '//fp.suning.com/bennu-collector/fp/porto.json', // 设备指纹接入方式配套url
  wxBind: BASE.passport + '/wechat/sports/web/bind', // username和openid绑定
  wxLogin: BASE.passport + '/wechat/sports/web/login', // 获取用户信息
  getWXSign: BASE.tysq + '/tysq-web/weChat/getSign', // 微信分享
  wxuserinfo: BASE.passport + '/wechat/sports/web/userinfo', // 查询微信头像昵称
  checkNeedVerifyMobile: BASE.passport + '/snsms/needverify', // 手机号登录风控
  checkverifycode: BASE.passport + '/snsms/checkverifycode', // 手机号风控校验
  sillerUrl: BASE.siller + 'detect/dt/dragDetect.json', // 滑块token取值
  imgUrl: BASE.imgUrl + 'vcs/imageCode.htm?uuid=', // 图片验证码图片地址
  getCode: BASE.passport + '/snsms/sendcode', // 获取验证码
  mobileMsgCheck: BASE.passport + '/snsms/verifycode', // 手机短信登录
  mobileMsgLogin: BASE.passport + '/snsms/loginregister', // 手机短信登录
  getHomePageInfo: BASE.lbgp + '/lbgp-web/homePage/homePageInfo', // H5推荐首页



  // 奥运竞猜活动
  queryRankDataList: BASE.sisp + '/olympicGuess/rankList.do', // 查询排行榜列表
  queryRankMaterialLogo: BASE.sisp + '/olympicGuess/pictureList.do', // 查询排行榜素材logo
  queryRankHeadInfo: BASE.sisp + '/olympicGuess/getUserInfo.do', // 查询排行榜头部信息
  subjectList: BASE.sisp + '/olympicGuess/subjectList.do', // H5查询题目，我的题目接口
  saveSubject: BASE.sisp + '/olympicGuess/saveSubject.do', // 答题接口
  activityHistoryAwardList: BASE.sisp + '/olympicGuess/activityHistoryAwardList.do', // 竞猜获奖记录接口
  getGifts: BASE.sisp + '/olympicGuess/getGifts.do', // 领取红包
  saveUserInfo: BASE.sisp + '/olympicGuess/saveUserInfo.do', // 提交获奖用户姓名电话地址信息接口
  

};

export default DI;

